import { default as indexcOXB8RchUWMeta } from "/builds/nht4944308/brands/umarketpro/webapp/pages/conversations/[sid]/index.vue?macro=true";
import { default as _91sid_93iXgrVRHTG0Meta } from "/builds/nht4944308/brands/umarketpro/webapp/pages/conversations/[sid].vue?macro=true";
import { default as indexyV6OCw6ATZMeta } from "/builds/nht4944308/brands/umarketpro/webapp/pages/index.vue?macro=true";
import { default as indexALFCWKIs9yMeta } from "/builds/nht4944308/brands/umarketpro/webapp/pages/login/agent/index.vue?macro=true";
import { default as agentjoqG1iiRegMeta } from "/builds/nht4944308/brands/umarketpro/webapp/pages/login/agent.vue?macro=true";
export default [
  {
    name: _91sid_93iXgrVRHTG0Meta?.name,
    path: "/conversations/:sid()",
    component: () => import("/builds/nht4944308/brands/umarketpro/webapp/pages/conversations/[sid].vue").then(m => m.default || m),
    children: [
  {
    name: "conversations-sid",
    path: "",
    component: () => import("/builds/nht4944308/brands/umarketpro/webapp/pages/conversations/[sid]/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/nht4944308/brands/umarketpro/webapp/pages/index.vue").then(m => m.default || m)
  },
  {
    name: agentjoqG1iiRegMeta?.name,
    path: "/login/agent",
    component: () => import("/builds/nht4944308/brands/umarketpro/webapp/pages/login/agent.vue").then(m => m.default || m),
    children: [
  {
    name: "login-agent",
    path: "",
    component: () => import("/builds/nht4944308/brands/umarketpro/webapp/pages/login/agent/index.vue").then(m => m.default || m)
  }
]
  }
]